/** Endpoint #27 — Profile mode: latest snapshot render + change log (§7.7). */
import { z } from 'zod';
import { IdSchema } from './common.js';
/** #27 `GET /api/views/:t/:id/profile` */
export const ProfileModeQuerySchema = z.object({
    /** Group views: which member to render; defaults to the first member. */
    memberId: IdSchema.optional(),
});
//# sourceMappingURL=profileMode.js.map